import { render, staticRenderFns } from "./veJkyProject.vue?vue&type=template&id=52e6f0bd&scoped=true"
import script from "./veJkyProject.vue?vue&type=script&lang=js"
export * from "./veJkyProject.vue?vue&type=script&lang=js"
import style0 from "./veJkyProject.vue?vue&type=style&index=0&id=52e6f0bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6f0bd",
  null
  
)

export default component.exports